import { extendTheme } from '@chakra-ui/react'

export const theme = {
    bgColor: '#FFF',
    dayBgColor: '#FFF',
    dayTextColor: '#000',
    nightBgColor: '#2d3748',
    nightTextColor: '#FFF',
    white: '#fff',
    blue: '#313095',
    blueTrans: 'rgba(49,48,149,0.7)',
    lightBlue: '#21ACFF',
    yellow: '#FAE823',
    yellowTrans: 'rgba(250,232,35,0.5)',
    darkText: '#000',
    lightText: '#7e7e7e',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontFamily_Roboto: "'Roboto', sans-serif",
}

export const ChakraTheme = extendTheme({
    initialColorMode: 'light',
    useSystemColorMode: true,
    colors: {
        brand: theme,
    },
    fonts: {
        heading: `Ripster, sans-serif`,
        body: `Avrt, sans-serif`,
    },
    breakpoints: {
        sm: '576px',
        md: '768px',
        lg: '960px',
        xl: '1200px',
        '2xl': '1536px',
    },
    sizes: {
        container: {
            sm: '30em', // 480px
            md: '48em', // 768px
            lg: '62em', // 992px
            xl: '80em', // 1280px
            '2xl': '96em', // 1536px
            full: '100vw', // full
        },
    },
    styles: {
        global: (props) => ({
            'html, body': {
                margin: 0,
                padding: 0,
                fontSize: '16px',
                color: props.colorMode === 'dark' ? 'white' : 'gray.700',
                backgroundColor:
                    props.colorMode === 'dark'
                        ? props.theme.colors.brand.nightBgColor
                        : props.theme.colors.brand.dayBgColor,
                lineHeight: 'tall',
            },
            main: {
                minHeight: '100vh',
            },
            '.mainContent': {
                minHeight: '100vh',
            },
            a: {
                color: props.colorMode === 'dark' ? props.theme.colors.brand.yellow : props.theme.colors.brand.blue,
                display: 'inline-block',
            },
            '.paragraph a': {
                fontWeight: 'bold',
            },
            ol: {
                paddingLeft: '30px',
                marginBottom: '20px',
            },
            ul: {
                paddingLeft: '30px',
                marginBottom: '20px',
            },
            hr: {
                margin: '30px 0',
            },
            blockquote: {
                display: 'block',
                position: 'relative',
                padding: '15px 20px 15px 45px',
                margin: '0 0 20px',
                borderLeft: '15px solid #ccc',
            },
            'blockquote::before': {
                content: '"\u201C"',
                fontSize: '60px',
                fontWeight: 'bold',
                position: 'absolute',
                left: '10px',
                top: '5px',
            },
            'blockquote::after': {
                content: '""',
            },
            '.paragraph': {
                marginTop: '20px',
            },
            '.chakra-card__body a': {
                display: 'block',
            },
            '.video-container': {
                position: 'relative',
                width: '100%',
                height: 0,
                paddingBottom: '56.25%',
            },
            '.video-container-short': {
                width: 'min(100%, 360px)',
                height: 'auto',
                paddingBottom: 0,
                aspectRatio: '9 / 16',
                margin: '0 auto',
            },
            '.video': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
            },
            h1: {
                fontSize: '3xl',
                margin: '15px 0',
                fontWeight: 'bold',
            },
            h2: {
                fontSize: '2xl',
                margin: '10px 0',
                fontWeight: 'bold',
            },
            h3: {
                fontSize: 'xl',
                margin: '10px 0',
                fontWeight: 'bold',
            },
            '.chakra-heading': {
                textTransform: 'uppercase',
            },
            '.avrt': {
                fontFamily: `Avrt, sans-serif !important`,
            },
            '.nomargin': {
                margin: '0 !important',
            },
            '.emailSpoof': {
                direction: 'rtl',
                unicodeBidi: 'bidi-override',
                cursor: 'pointer',
            },
        }),
    },
})
